import * as React from "react";
import * as LanguageTexts from "@genesys/shared/lib/language-texts";
import * as OperationTimeGen2 from "../../../../operation-time-manager";
import styled from "styled-components";
import { Action } from "../state";
import { Dispatch } from "@typescript-tea/core";
import { OperationTimeView } from "../../../components/operation-time";
import { InternalProps } from "../types";
import { StyledH3, FlexContainerCenter } from "../local-elements";

const AlignCenter = styled(FlexContainerCenter)`
  align-items: center;
  padding-top: 10px;

  > label {
    margin-right: 17px;
    margin-left: 17px;
    font-size: 14px;
  }

  > span {
    cursor: pointer;
  }
`;

export function SystemOperationTime(props: InternalProps) {
  const {
    state,
    sharedState,

    isDisabled,

    dispatch
  } = props;

  const labelRef = React.useRef<HTMLLabelElement>(null);

  return (
    <div>
      <StyledH3>
        {sharedState.translate(LanguageTexts.mlcSystemOperationTime())}
      </StyledH3>
      <AlignCenter>
        <label ref={labelRef}>
          {sharedState.translate(
            LanguageTexts.dynamicText(
              "mlc" + OperationTimeGen2.presetName(state.operationTimeState!)
            )
          )}
          :
        </label>
        <OperationTimeView
          labelRef={labelRef}
          sharedState={sharedState}
          dispatch={Dispatch.map(Action.dispatchOperationTime, dispatch)}
          readonly={isDisabled}
          operationTimeState={state.operationTimeState}
        />
      </AlignCenter>
    </div>
  );
}
